import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useCallback } from 'react';
import NavCollapseTrigger from './NavCollapseTrigger';
import * as S from './styles';

var useCollapse = function useCollapse(_ref) {
  var defaultCollapsed = _ref.defaultCollapsed,
      collapsed = _ref.collapsed,
      onCollapseTriggerClick = _ref.onCollapseTriggerClick;
  var isControlled = typeof collapsed === 'boolean';

  var _useState = useState(defaultCollapsed),
      _useState2 = _slicedToArray(_useState, 2),
      collapsedState = _useState2[0],
      setCollapsedState = _useState2[1]; // 是否是受控组件？


  var actualCollapsed = isControlled ? collapsed : collapsedState; // 装饰onCollapseTriggerClick，在受控模式下要设置当前collapsedState

  var actualOnCollapseTriggerClick = useCallback(function (e) {
    onCollapseTriggerClick && onCollapseTriggerClick(actualCollapsed, e);

    if (!isControlled) {
      setCollapsedState(!actualCollapsed);
    }
  }, [actualCollapsed, isControlled, onCollapseTriggerClick]);
  return [actualCollapsed, actualOnCollapseTriggerClick];
};

var Nav = function Nav(_ref2) {
  var _ref2$collapsible = _ref2.collapsible,
      collapsible = _ref2$collapsible === void 0 ? true : _ref2$collapsible,
      collapsed = _ref2.collapsed,
      _ref2$defaultCollapse = _ref2.defaultCollapsed,
      defaultCollapsed = _ref2$defaultCollapse === void 0 ? false : _ref2$defaultCollapse,
      onCollapseTriggerClick = _ref2.onCollapseTriggerClick,
      children = _ref2.children;

  var _useCollapse = useCollapse({
    collapsed: collapsed,
    defaultCollapsed: defaultCollapsed,
    onCollapseTriggerClick: onCollapseTriggerClick
  }),
      _useCollapse2 = _slicedToArray(_useCollapse, 2),
      derivedCollapsed = _useCollapse2[0],
      derivedOnCollapseTriggerClick = _useCollapse2[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(S.Nav, {
    collapsed: derivedCollapsed,
    className: "windcc-app-layout__nav"
  }, /*#__PURE__*/React.createElement(S.NavChildenWrapper, null, children)), collapsible && /*#__PURE__*/React.createElement(NavCollapseTrigger, {
    collapsed: derivedCollapsed,
    onClick: derivedOnCollapseTriggerClick
  }));
};

export default Nav;